import actions from '../../actionTypes';

export default action => {
  return {
    type: actions.EDIT_ACTION,
    action
  };
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/actions/editAction.js